import React, {useState, useContext, useEffect} from "react";
import { NamePositionContext } from "../../contexts/NamePositionContext";

const InputName = (props) => {
    const [name,setName] = useState("");
    const {dispatch} = useContext(NamePositionContext);

    const handleChange = (e) => setName(e.target.value);
    
    useEffect(() => {
        dispatch({ type: 'UPDATE_NAME', name })
    }, [name])
    return (
        <div className='input-details'>
            <input onChange={handleChange}
                placeholder={props.name}
                style={props.nameStyleObj} />
        </div>
    )};

export default InputName;
